import React from 'react';
import OnboardingSection from '../OnboardingSection';

type OnboardingServicesProps = {
  onEdit: () => void;
};

const OnboardingServices: React.FCWithChildren<OnboardingServicesProps> = ({ onEdit }) => (
  <OnboardingSection
    onClick={onEdit}
    label="Set up prices & services"
    testID="onboardingServices"
  />
);

export default OnboardingServices;
